import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Copy, MessageCircle, Loader2, Link2 } from "lucide-react";

export default function PortalInviteDialog({ emp, q, onClose }) {
  const [res, setRes] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.post(`/employee-portal/admin/invite/${emp.id}${q || ""}`).then(({ data }) => setRes(data))
      .catch((e) => setErr(e.response?.data?.detail || "Could not create link"));
  }, [emp.id, q]);
  const url = res ? `${window.location.origin}${res.link}` : "";
  const copy = () => { navigator.clipboard?.writeText(url); toast.success("Link copied"); };
  const wa = `https://wa.me/${(emp.phone || "").replace(/\D/g, "")}?text=${encodeURIComponent(`Hi ${emp.name}, open your SUNTRONIX employee portal here (valid 72 hours): ${url}`)}`;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="portal-invite-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Link2 className="h-4 w-4" /> Employee Portal link · {emp.name}</DialogTitle></DialogHeader>
        {!res && !err && <div className="flex items-center gap-2 text-sm text-slate-500 py-4"><Loader2 className="h-4 w-4 animate-spin" /> Creating a secure one-time link…</div>}
        {err && <p className="text-sm text-rose-600" data-testid="portal-invite-error">{err}</p>}
        {res && (
          <div className="space-y-3 text-sm">
            <p className="text-slate-600">One-time sign-in link, valid {res.expires_in_hours} hours. {res.channels.includes("link_only") ? "Automatic delivery is not available right now — share it with the employee yourself." : `Sent via ${res.channels.join(", ")}.`}</p>
            <div className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 font-mono text-[11px] break-all" data-testid="portal-invite-link">{url}</div>
            <div className="flex gap-2 flex-wrap">
              <Button size="sm" variant="outline" onClick={copy} data-testid="portal-invite-copy"><Copy className="h-3.5 w-3.5 mr-1" /> Copy link</Button>
              {emp.phone && <a href={wa} target="_blank" rel="noreferrer" className="inline-flex items-center h-8 px-3 rounded-md text-[13px] font-medium bg-emerald-600 text-white hover:bg-emerald-700" data-testid="portal-invite-whatsapp"><MessageCircle className="h-3.5 w-3.5 mr-1" /> Share on WhatsApp</a>}
            </div>
            <p className="text-[11px] text-slate-400">The employee can also sign in any time at <span className="font-mono">{window.location.origin}/me</span> with a 6-digit code sent to their work email or mobile.</p>
          </div>
        )}
        <DialogFooter><Button variant="outline" onClick={onClose}>Done</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
